import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { CustomFields, filterCustomFieldsConfig } from "../../fields/CustomFields";
/* eslint-disable react/prop-types */

export const PublishingSectionCmp = ({ record, customFieldsUI, formik }) => {
  const resourceType = formik.form.values.metadata.resource_type;
  const config = filterCustomFieldsConfig(customFieldsUI, "publishing", resourceType);
  return <CustomFields record={record} config={config} resourceType={resourceType} />;
};

PublishingSectionCmp.propsTypes = {
  record: PropTypes.object.isRequired,
  customFieldsUI: PropTypes.arrayOf(
    PropTypes.shape({
      section: PropTypes.string.isRequired,
      displaySection: PropTypes.bool,
      fields: PropTypes.arrayOf(
        PropTypes.shape({
          field: PropTypes.string.isRequired,
          ui_widget: PropTypes.string.isRequired,
          props: PropTypes.object,
        })
      ),
    })
  ).isRequired,
  formik: PropTypes.object.isRequired,
};

export const PublishingSection = (props) => {
  return (
    <Field>{(formik) => <PublishingSectionCmp formik={formik} {...props} />}</Field>
  );
};

PublishingSection.propsTypes = {
  record: PropTypes.object.isRequired,
  customFieldsUI: PropTypes.arrayOf(
    PropTypes.shape({
      section: PropTypes.string.isRequired,
      displaySection: PropTypes.bool,
      fields: PropTypes.arrayOf(
        PropTypes.shape({
          field: PropTypes.string.isRequired,
          ui_widget: PropTypes.string.isRequired,
          props: PropTypes.object,
        })
      ),
    })
  ).isRequired,
};

PublishingSection.defaultProps = {};
